import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {SafeUrl} from '@angular/platform-browser';
import {Params} from '@angular/router';
import {CmsComponentData} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {filter} from 'rxjs/operators';

import {AimoCMSSimpleBannerComponent} from '../../../model/cms.model';
import {GTMContentType, GTMCreativeSlot, GTMEventCode} from '../../../service/gtm/aimo-gtm.model';
import {AimoGtmService} from '../../../service/gtm/aimo-gtm.service';
import {SafeUrlPipe} from '../utils/safe-html/aimo-pipes';

@Component({
    selector: 'aimo-simple-banner',
    templateUrl: './aimo-simple-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoSimpleBannerComponent implements OnInit {
    @Input() banner: AimoCMSSimpleBannerComponent;

    componentData$: Observable<AimoCMSSimpleBannerComponent>;

    constructor(
        protected component: CmsComponentData<AimoCMSSimpleBannerComponent>,
        protected gtmService: AimoGtmService,
        public safeUrlPipe: SafeUrlPipe,
    ) {
    }

    ngOnInit(): void {
        this.componentData$ = this.component.data$.pipe(
            filter(Boolean),
        );
    }

    buttonClicked(banner: AimoCMSSimpleBannerComponent): void {
        this.gtmEvent(banner, GTMEventCode.SelectPromotion);
    }

    private gtmEvent(banner: AimoCMSSimpleBannerComponent, event: GTMEventCode): void {
        this.gtmService.pushContentEvent(
            this.defineCreativeSlot(banner),
            banner.name,
            GTMContentType.aimo,
            banner.gtmCustomer?.code,
            event,
        );
    }

    private defineCreativeSlot(banner: AimoCMSSimpleBannerComponent): GTMCreativeSlot {
        return GTMCreativeSlot.seasons_page_banner;
    }

    isExternal(data: AimoCMSSimpleBannerComponent): boolean | null {
        return data?.external === 'true' || data?.external === true;
    }

    getTarget(data: AimoCMSSimpleBannerComponent): string | null {
        return this.isExternal(data) ? '_blank' : null;
    }

    getSafeUrl(url): SafeUrl {
        return this.safeUrlPipe.transform(url);
    }

    getInternalQueryParams(banner: AimoCMSSimpleBannerComponent): Params {
        return {
            promotion_id: banner.uid,
            promotion_name: banner.name,
        };
    }
}
